import { render, staticRenderFns } from "./EmojiPickerAction.vue?vue&type=template&id=7a95ebd4"
import script from "./EmojiPickerAction.vue?vue&type=script&lang=js"
export * from "./EmojiPickerAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports